import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '~/src/layouts/component-layout';
import { AccessibilityLink } from '~/src/components/accessibility-link';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <img role="presentation" width="960" src="https://user-images.githubusercontent.com/2313998/226466889-81266a65-6099-457f-9770-99e4c3a0d712.png" />
    <h2>{`Usage`}</h2>
    <p>{`Use an icon button when the purpose of your button may be easily understood using an icon in place of a text label.`}</p>
    <h3>{`Best practices`}</h3>
    <ul>
      <li parentName="ul">{`Verify that the button's purpose will still be understood using an icon without a text label. Consider your audience and the context where the button is being rendered.`}</li>
      <li parentName="ul">{`Use a tooltip with a text label for the button so users can hover or focus the button to read a button label that makes it clear what the button does.`}</li>
    </ul>
    <h2>{`Options`}</h2>
    <p>{`Icon buttons have the same `}<a parentName="p" {...{
        "href": "/components/button#sizing-and-spacing"
      }}>{`size`}</a>{` and `}<a parentName="p" {...{
        "href": "/components/button#color"
      }}>{`variant`}</a>{` options as a button with a text label.`}</p>
    <h2>{`Accessibility`}</h2>
    <p>{`Even though the label is visually hidden, a text label needs to be defined so a screen reader can read that label to the user.`}</p>
    <h3>{`Known accessibility issues (GitHub staff only)`}</h3>
 <AccessibilityLink label="IconButton" mdxType="AccessibilityLink" />
    <h2>{`Related links`}</h2>
    {/* TODO: link to Tooltip once it's merged */}
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/ui-patterns/button-usage"
        }}>{`Button usage`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/button"
        }}>{`Button`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      